import { render, staticRenderFns } from "./checkout-total-group.vue?vue&type=template&id=19109012&"
import script from "./checkout-total-group.vue?vue&type=script&lang=js&"
export * from "./checkout-total-group.vue?vue&type=script&lang=js&"
import style0 from "./checkout-total-group.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19109012')) {
      api.createRecord('19109012', component.options)
    } else {
      api.reload('19109012', component.options)
    }
    module.hot.accept("./checkout-total-group.vue?vue&type=template&id=19109012&", function () {
      api.rerender('19109012', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/checkout/checkout-total/checkout-total-group.vue"
export default component.exports